import {Link, useLocation, useNavigate} from "react-router-dom";
import {ChevronLeft, ChevronRight, House} from "lucide-react";
import GoBackHeader from "../components/GoBackHeader.tsx";
import React, {FC, useRef, useState} from "react";
import TicketItem from "../components/Ticket";
import {getMyFilteredTickets} from "../api/services.ts";
import Routes from "../utils/routes.ts";

interface Props {
  icon: React.ReactElement;
  disabled: boolean;
  onClick: () => void;
}

const TicketsSlideButton: FC<Props> = ({ icon, onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="flex border items-center justify-center border-black rounded-full shadow-sm w-8 h-8"
    >
      {icon}
    </button>
  );
};

export default function Ticket() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const itemWidth = 100; // 100% de la largeur du conteneur
  const itemSpacing = 2; // 2 * 0.5rem (mx-2 équivaut à 0.5rem de chaque côté)
  const totalItemWidth = itemWidth + itemSpacing;
  const navigate = useNavigate();

  const { state } = useLocation();
  const brutVouchers = state?.vouchers;

  const vouchers = getMyFilteredTickets(brutVouchers);

  const goToPrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const goToNext = () => {
    if (currentIndex < vouchers?.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const swipeDistance = touchEndX.current - touchStartX.current;
    if (Math.abs(swipeDistance) > 50) {
      if (swipeDistance > 0 && currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      } else if (swipeDistance < 0 && currentIndex < vouchers?.length - 1) {
        setCurrentIndex(currentIndex + 1);
      }
    }
  };

    return (
        <div
            style={{
                backgroundImage: `url('/pattern-14.png')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
            className="min-h-screen p-4 flex flex-col justify-between"
        >
            <div className="w-full">
                {/* Header */}
                <GoBackHeader icon={<House color="#fff" className="w-6 h-6 "/>} onBackPress={() => navigate('/')}/>

                <div className='flex w-full h-full items-center flex-row justify-between '>
                    {vouchers?.length > 1 && <TicketsSlideButton
                        onClick={goToPrevious}
                        disabled={currentIndex === 0}
                        icon={<ChevronLeft color='#000'/>}
                    />}
                    <div
                        className={`${vouchers?.length > 1 ? 'w-[80%]' : 'w-full'} flex flex-col items-center justify-center mx-1`}>
                        <div className="w-full overflow-x-hidden relative ">
                            <div
                                className="relative flex w-full"
                                onTouchStart={handleTouchStart}
                                onTouchMove={handleTouchMove}
                                onTouchEnd={handleTouchEnd}
                            >
                                <div
                                    className="flex w-full transition-transform duration-300 ease-in-out "
                                    style={{
                                        transform: `translateX(calc(-${currentIndex * totalItemWidth}% - ${currentIndex * 0.1}rem))`,
                                        //marginLeft: "-0.1rem", // Compenser le mx-2 du premier élément
                                        //marginRight: "-0.2rem", // Compenser le mx-2 du dernier élément
                                    }}
                                >
                                    {vouchers?.length > 0 && vouchers?.map((voucher: any, index: number) => (
                                        <TicketItem ticket={voucher} currentIndex={index}
                                                    totalTickets={vouchers?.length || 0}/>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>
                    {vouchers?.length > 1 && <TicketsSlideButton
                        onClick={goToNext}
                        disabled={currentIndex === vouchers?.length - 1}
                        icon={<ChevronRight color='#000'/>}
                    />}
                </div>
            </div>

            <div className="flex flex-col justify-center items-center mt-2 w-full">
                <Link
                    className="bg-white w-full self-center border border-third  flex items-center justify-center text-third font-semibold py-4 px-4 rounded-full w-3/4 max-w-xs mt-2"
                    to={`/${Routes["Evenements de l'utilisateur"]}`}>
                    Voir tout mes tickets
                </Link>
            </div>
        </div>
    );
};
